import { Injectable } from "@angular/core";
import { LOCAL_SETTINGS } from "../../local-settings";

@Injectable({
    providedIn: "root",
})
export class LocalStorageService {
    constructor() {}

    setToken(value: string) {
        localStorage.setItem(LOCAL_SETTINGS.localStorageKeys.tokenKey, value);
    }

    getToken() {
        return localStorage.getItem(LOCAL_SETTINGS.localStorageKeys.tokenKey);
    }

    removeToken() {
        localStorage.removeItem(LOCAL_SETTINGS.localStorageKeys.tokenKey);
    }

    setRememberMe(value: boolean) {
        localStorage.setItem(LOCAL_SETTINGS.localStorageKeys.rememberMeKey, value.toString());
    }

    getRememberMe() {
        return localStorage.getItem(LOCAL_SETTINGS.localStorageKeys.rememberMeKey) === "true";
    }

    removeRememberMe() {
        localStorage.removeItem(LOCAL_SETTINGS.localStorageKeys.rememberMeKey);
    }

    setRememberedUserEmail(email: string) {
        localStorage.setItem(LOCAL_SETTINGS.localStorageKeys.rememberedUserEmailKey, email);
    }
    getRememberedUserEmail() {
        return localStorage.getItem(LOCAL_SETTINGS.localStorageKeys.rememberedUserEmailKey);
    }

    removeRememberedUserEmail() {
        localStorage.removeItem(LOCAL_SETTINGS.localStorageKeys.rememberedUserEmailKey);
    }
}
